<template>
    <ContentCard icon="assets/images/illu-ocean.svg">
        <template #title>Water Filter</template>
        <template #description>
            Learn how to make your own water filter with Parklands Education Ranger Louise.
        </template>
        <template #buttons>
            <ButtonPill icon="play" class="card__btn me-8"
                        @click.native="$store.commit('SET_LIGHTBOX', 'rQAimQG_5-s')">Watch Now
            </ButtonPill>
            <ButtonPill href="/pdfs/make-a-water-filter.pdf" target="_blank" icon="file"
                        class="card__btn" orange>ACTIVITY
            </ButtonPill>
        </template>
    </ContentCard>
</template>

<script>
import ContentCard from '@/components/ContentCard';
import ButtonPill from '@/components/ButtonPill';
export default {
    components: {ButtonPill, ContentCard}
};
</script>

<style scoped lang="scss">
::v-deep .card__illu {
    top: 30%;
    transform: none;
}
</style>
